import { ReceiptText } from "components/icons/customIcons";
import { AbpPolicies } from "core/constants/AbpPolicies";
import { BarChart3, KeyRound, Building2, Calculator, ClipboardCheck, FileText, LayoutGrid, Paperclip, Users, NotebookPen, Lightbulb, Info } from "lucide-react";
import { MenuItem } from "./DashboardMenuItem";

export const menuItems: MenuItem[] = [
  {
    id: 'dashboard',
    label: 'SIDEBAR.DASHBOARD',
    icon: LayoutGrid,
    to: '/bord'
  },
  {
    id: 'statistics',
    courtierOnly: true,
    label: 'SIDEBAR.MY_STATS',
    icon: BarChart3,
    to: '/mes-statistiques'
  },
  {
    id: 'contracts',
    courtierOnly: true,
    label: 'SIDEBAR.MY_CONTRACTS',
    icon: FileText,
    to: '/mes-contrats',
    permission: AbpPolicies.CONTRATS_READ
  },
  {
    // Lecture portée par les briques Consultation portefeuille orga, Souscription
    // plateforme et Consultation porteur de risque (et Distribution côté courtier)
    // — sans l'une d'elles, pas d'entrée (la route redirige de toute façon).
    id: 'collectiveContracts',
    label: 'SIDEBAR.MY_COLLECTIVE_CONTRACTS',
    icon: Users,
    to: '/mes-contrats-collectifs',
    permission: AbpPolicies.CONTRATS_DE_GROUPE_READ
  },
  {
    // Validations de devis : visible sous le Portail Gestion seulement (brique
    // Valideur, cf. menuPolicy).
    id: 'validations',
    label: 'SIDEBAR.VALIDATIONS',
    icon: ClipboardCheck,
    to: '/validations',
    permission: AbpPolicies.VALIDATIONS_READ,
    badge: 'pendingValidations'
  },
  {
    id: 'quotes',
    courtierOnly: true,
    label: 'SIDEBAR.MY_QUOTES',
    icon: ReceiptText,
    to: '/mes-devis',
    permission: AbpPolicies.DEVIS_READ
  },
  {
    id: 'simulations',
    courtierOnly: true,
    label: 'SIDEBAR.MY_SIMULATIONS',
    icon: Calculator,
    to: '/mes-simulations',
    permission: AbpPolicies.SIMU_READ
  },
  {
    id: 'clients',
    courtierOnly: true,
    label: 'SIDEBAR.MY_CLIENTS',
    icon: Users,
    to: '/mes-clients',
    permission: AbpPolicies.ACTEURS_ASSURE
  },
  {
    // Visibilité pilotée par la matrice centrale (roleCapabilities : rôle Plateforme).
    id: 'orgBrokers',
    // Même vocabulaire que l'onglet « Intermédiaires » du BO plateforme.
    // Courtiers.Read n'est porté que par la Consultation portefeuille orga :
    // une session Conception d'offre / Souscription plateforme seule ne voit pas
    // l'entrée (le back refuserait la liste).
    label: "Intermédiaires",
    icon: Building2,
    to: '/mes-courtiers',
    permission: AbpPolicies.COURTIERS_READ
  },
  {
    // Leads partenaires : gestionnaire (permission LEADS_MANAGE) — périmètre serveur
    id: 'leadsPartners',
    label: 'Leads partenaires',
    icon: Lightbulb,
    to: '/mes-leads-partenaires',
    permission: AbpPolicies.LEADS_MANAGE
  },
  {
    id: 'documents',
    label: 'SIDEBAR.MY_DOCUMENTS',
    icon: Paperclip,
    to: '/mes-documents',
    permission: AbpPolicies.DOCUMENTS_READ
  },
  {
    id: 'myNotes',
    courtierOnly: true,
    label: 'SIDEBAR.MY_NOTES',
    icon: NotebookPen,
    to: '/mes-notes'
  },
  {
    id: 'espaceInfo',
    label: 'SIDEBAR.ESPACE_INFO',
    icon: Info,
    to: '/espace-info'
  },
  // --- Espace compagnie (PM principale de son plateforme) ---
  {
    id: 'mesCourtiers',
    label: 'SIDEBAR.MY_BROKERS',
    icon: Users,
    to: '/mes-courtiers',
    compagnieOnly: true,
    permission: AbpPolicies.COURTIERS_READ
  },
  {
    id: 'rolesCourtiers',
    label: 'Rôles',
    icon: KeyRound,
    to: '/roles-courtiers',
    compagnieOnly: true
  },
  {
    id: 'habilitationsTunnels',
    label: 'SIDEBAR.TUNNEL_HABILITATIONS',
    icon: Lightbulb,
    to: '/mes-habilitations-tunnels',
    compagnieOnly: true
  }
];
